import { render } from "./AppHeader.vue?vue&type=template&id=0f50e2b7&scoped=true"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0f50e2b7"

export default script